import Vue from './vue.js?vue3';
import {
  createStore,
  mapState,
  mapGetters,
  mapActions,
  mapMutations,
  createNamespacedHelpers,
} from '../../../../../../node_modules/@gitlab/vuex-vue3/dist/vuex.esm-bundler.js?vue3';
import { PLUGIN_MIXIN, VUEX } from './plugin_install_state';

export { mapState, mapGetters, mapActions, mapMutations, createNamespacedHelpers };

const installedStores = new WeakMap();

export default {
  Store: class VuexCompatStore {
    constructor(...args) {
      // eslint-disable-next-line no-constructor-return
      return createStore(...args);
    }
  },

  install() {
    Vue.mixin({
      [PLUGIN_MIXIN]: VUEX,
      beforeCreate() {
        const { app } = this.$.appContext;
        const { store } = this.$options;
        if (store && !installedStores.get(app)?.has(store)) {
          if (!installedStores.has(app)) {
            installedStores.set(app, new WeakSet());
          }
          installedStores.get(app).add(store);
          this.$.appContext.app.use(this.$options.store);
        }
      },
    });
  },
};
